import { render } from "./BetRecord.vue?vue&type=template&id=9d99370c&scoped=true"
import script from "./BetRecord.vue?vue&type=script&lang=js"
export * from "./BetRecord.vue?vue&type=script&lang=js"

import "./BetRecord.vue?vue&type=style&index=0&id=9d99370c&lang=less&scoped=true"

import exportComponent from "D:\\xm\\zhongzai\\qianduan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d99370c"]])

export default __exports__